import React, { Component } from 'react';
import { Modal, Form, InputNumber, Select } from 'antd';
import { inject, observer } from 'mobx-react/index';
const Option = Select.Option;

@inject('store')
@observer
export class DCAModal extends Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }

    render() {
        const position = this.props.position;
        return (
            <Modal
                title="DCA"
                width={450}
                visible={this.props.visible}
                onCancel={() => {
                    this.form.current.resetFields();
                    this.props.onCancel();
                }}
                onOk={() => {
                    this.form.current.validateFieldsAndScroll((err, values) => {
                        if (!err) {
                            this.props.store.botStore.actionStore.execute('dca_position', {
                                position_id: position.id,
                                ...values
                            });
                            this.form.current.resetFields();
                            this.props.onCancel();
                        }
                    });
                }}
            >
                <DCAForm ref={this.form} position={this.props.position} />
            </Modal>
        );
    }
}

@inject('store')
@observer
class DCAFormComponent extends Component {
    render() {
        const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
        const position = this.props.position;
        const orderType = getFieldValue('order_type');

        const price = this.props.store.botStore.marketStore.getByName(position.symbol);

        if (!position) return null;
        return (
            <Form>
                <Form.Item
                    label="Multiplier"
                    required={true}
                    extra={'How much you should the position be increased by: 1 = 100%'}
                >
                    {getFieldDecorator('multiplier', {
                        initialValue: 1,
                        rules: [{ required: true, message: 'Field is required' }]
                    })(<InputNumber style={{ width: '100%' }} />)}
                </Form.Item>
                <Form.Item label="Order Type" required={true}>
                    {getFieldDecorator('order_type', {
                        initialValue: 'market',
                        rules: [{ required: true, message: 'Field is required' }]
                    })(
                        <Select style={{ width: '100%' }} visible={false}>
                            <Option value={'market'}>Market</Option>
                            <Option value={'limit'}>Limit</Option>
                        </Select>
                    )}
                </Form.Item>

                <div
                    style={{
                        background: 'rgba(0,0,0,0.2)',
                        padding: 5,
                        borderRadius: 2,
                        marginTop: 5
                    }}
                >
                    Price:{' '}
                    <a onClick={() => setFieldsValue({ limit_price: price.last })}>{price.last}</a>
                    <br />
                    Ask:{' '}
                    <a onClick={() => setFieldsValue({ limit_price: price.ask })}>{price.ask}</a>
                    <br />
                    Bid:{' '}
                    <a onClick={() => setFieldsValue({ limit_price: price.bid })}>{price.bid}</a>
                </div>

                {orderType === 'limit' ? (
                    <Form.Item label="Price" required={true}>
                        {getFieldDecorator('limit_price', {
                            initialValue: '0',
                            rules: [{ required: true, message: 'Field is required' }]
                        })(<InputNumber style={{ width: '100%' }} />)}
                    </Form.Item>
                ) : (
                    <span />
                )}
            </Form>
        );
    }
}

export const DCAForm = Form.create()(DCAFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionsView/DCAModal.js